import request from "@/utils/hotelRequest";

// 获取嘉银已开通页面信息
export const getJiayinDetail = params => {
  return request({
    url: "/api/core/jiayin/benefits_info",
    method: "get",
    params
  });
};

// 获取嘉银分期账单
export const getJiayinBill = data => {
  return request({
    url: "/api/core/jiayin/bill_order",
    method: "POST",
    data
  });
};

// 获取嘉银分期账单
export const getJiayinPaymentInfo = data => {
  return request({
    url: "/api/core/jiayin/query_pay_info",
    method: "POST",
    data
  });
};

// 获取嘉银分期账单
export const jiayinPaymentPay = data => {
  return request({
    url: "/api/core/jiayin/payment_pay",
    method: "POST",
    data
  });
};

// 获取嘉银支付结果
export const jiayinPaymentResult = data => {
  return request({
    url: "/api/core/jiayin/query_pay_result",
    method: "POST",
    data
  });
};

// 查询嘉银是否可以取消续费操作
export const jiayinQueryMonthlySubscription = data => {
  return request({
    url: "/api/core/jiayin/user_query_continuous",
    method: "POST",
    data
  });
}

// 取消连续包月
export const cancelMonthlySubscription = data => {
  return request({
    url: "/api/core/jiayin/user_cancel_continuous",
    method: "POST",
    data
  });
}

// 取消扣费
export const cancelDeduction = data => {
  return request({
    url: "/api/core/jiayin/user_cancel_benefit",
    method: "POST",
    data
  });
}

// 嘉银退款
export const fetchRefund = data => {
  return request({
    url: "/api/core/jiayin/user_apply_refund",
    method: "POST",
    data
  })
}

// 获取嘉银金融权益跳转链接
export const getJiayinJumpLink = data => {
  return request({
    url: "/api/core/jiayin/get_coupon_url",
    method: "POST",
    data
  })
}